import { useState, useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { api } from '../utils/api'
import EditPartyModal from '../components/EditPartyModal'

export default function PartyDetails() {
  const { id } = useParams()
  const [party, setParty] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [showEditModal, setShowEditModal] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    fetchParty()
    // eslint-disable-next-line
  }, [id])

  const fetchParty = async () => {
    setLoading(true)
    setError("")
    try {
      const res = await api.get(`/parties/${id}`)
      setParty(res.data.data)
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to fetch party')
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this party?')) return
    try {
      await api.delete(`/parties/${id}`)
      navigate('/parties')
    } catch (err) {
      alert(err.response?.data?.message || err.message || 'Failed to delete party')
    }
  }

  const handleEditParty = (updatedParty) => {
    setParty(updatedParty)
    setShowEditModal(false)
  }

  if (loading) return <div>Loading...</div>
  if (error) return <div className="text-red-600">{error}</div>
  if (!party) return null

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-4">Party Details</h1>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 mb-4">
        <div className="mb-2"><strong>Name:</strong> {party.name}</div>
        <div className="mb-2"><strong>Email:</strong> {party.email}</div>
        <div className="mb-2"><strong>Phone:</strong> {party.phone}</div>
        <div className="mb-2"><strong>Address:</strong> {party.address}</div>
        <div className="mb-2"><strong>Type:</strong> {party.partyType}</div>
        <div className="mb-2"><strong>GST Number:</strong> {party.gstNumber}</div>
        <div className="mb-2"><strong>Balance:</strong> ₹{(party.balance ?? 0).toLocaleString()}</div>
        <div className="mb-2"><strong>Created At:</strong> {party.createdAt ? new Date(party.createdAt).toLocaleString() : ''}</div>
        <div className="mb-2"><strong>Updated At:</strong> {party.updatedAt ? new Date(party.updatedAt).toLocaleString() : ''}</div>
        <div className="mt-4 flex gap-2">
          <button className="px-4 py-2 bg-indigo-600 text-white rounded" onClick={() => setShowEditModal(true)}>Edit</button>
          <button className="px-4 py-2 bg-red-600 text-white rounded" onClick={handleDelete}>Delete</button>
          <button className="px-4 py-2 bg-gray-300 rounded" onClick={() => navigate('/parties')}>Back</button>
        </div>
      </div>
      {showEditModal && (
        <EditPartyModal open={showEditModal} onClose={() => setShowEditModal(false)} party={party} onEditParty={handleEditParty} />
      )}
    </div>
  )
} 